import { ReactComponent as EngravingLogoSVG } from '@/assets/engraving-color.svg';

import * as S from './EngravingLogo.styles';

export interface EngravingLogoProps {
  height?: number;
  width?: number;
}

export const EngravingLogo = ({ height, width }: EngravingLogoProps) => {
  return (
    <S.EngravingLogoWrapper $height={height} $width={width}>
      <EngravingLogoSVG
        aria-hidden='true'
        data-testid='EngravingLogo'
        focusable='false'
        height={height}
        preserveAspectRatio='xMidYMid meet'
        viewBox='0 0 96 96'
        width={width}
      />
    </S.EngravingLogoWrapper>
  );
};
